import { call, put, takeLatest } from 'redux-saga/effects';
import { sendResetPassEmail } from './service';
import { sendResetPassEmailStart } from './actions';
import { loading, success, failure } from './slice';
import { Action } from '@reduxjs/toolkit';

function* sendUserResetPassEmailFlow(action: Action<unknown>) {
  if (sendResetPassEmailStart.match(action)) {
    try {
      yield put(loading());
      yield call(sendResetPassEmail, action.payload.email);
      yield put(success());
    } catch (error) {
      const { message }: { message: string } = error?.response?.data || error;
      const statusCode: number = error?.response?.status;
      yield put(failure({ message, statusCode }));
    }
  }
}

export function* onSendResetPassEmailStart() {
  yield takeLatest(sendResetPassEmailStart, sendUserResetPassEmailFlow);
}
